import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import { showDialogOverlay, hideDialogOverlay } from "../../../../utils/dialogOverlay.js";
import IMask from "imask";
import { KisilerDraft } from "./KisilerDraft.js";
import { renderKisilerGrid } from "../../kisilerGrid.js";
import { uiState } from "../../../../state/uiState.js";
import { truncateLabel } from "../../../../utils/textPresentation.js";

const API = "/api";
let didBind = false;

function ensureKisilerCreateDialog() {
	if (document.getElementById("kisilerCreateDialog")) return;
	document.body.insertAdjacentHTML("beforeend", `
<dialog id="kisilerCreateDialog">
    <form method="dialog" novalidate class="create-dialog-container">
        <div class="create-dialog-header">
            <h4>Ki\u015fi Ekle</h4>
        </div>
        <div class="create-dialog-content">
            <div class="kisi-bilgiler section">
                <div class="section-1-header"><h5>Ki\u015fi Bilgileri</h5></div>
                <div class="section-1-content">
                    <div class="column-container kisiler-tc">
                        <label for="kisiler_tc">T.C. Kimlik No:</label>
                        <input id="kisiler_tc" class="form-input" type="text" name="tc" maxlength="11" placeholder="11 haneli TC kimlik numaras\u0131" required autocomplete="off" inputmode="numeric" />
                        <span class="info" data-focus="11 haneli TC kimlik numaras\u0131 girin." data-invalid="TC kimlik numaras\u0131 11 rakamdan olu\u015fmal\u0131d\u0131r."></span>
                    </div>
                    <div class="column-container kisiler-ad">
                        <label for="kisiler_first_name">Ad:</label>
                        <input id="kisiler_first_name" class="form-input" type="text" name="first_name" maxlength="100" placeholder="Ki\u015finin ad\u0131n\u0131 giriniz" required />
                        <span class="info" data-focus="Ki\u015finin ad\u0131n\u0131 girin." data-invalid="Sadece harf, bo\u015fluk veya tire girebilirsiniz."></span>
                    </div>
                    <div class="column-container kisiler-soyad">
                        <label for="kisiler_last_name">Soyad:</label>
                        <input id="kisiler_last_name" class="form-input" type="text" name="last_name" maxlength="100" placeholder="Ki\u015finin soyad\u0131n\u0131 giriniz" required />
                        <span class="info" data-focus="Ki\u015finin soyad\u0131n\u0131 girin." data-invalid="Sadece harf, bo\u015fluk veya tire girebilirsiniz."></span>
                    </div>
                    <div class="column-container kisiler-departman">
                        <label for="kisiler_departman">Departman:</label>
                        <select id="kisiler_departman" class="form-select" name="kisi_departman_id" required>
                            <option value="" selected>Departman se\u00e7iniz</option>
                        </select>
                        <span class="info" data-focus="Departman se\u00e7iniz." data-invalid="Ge\u00e7erli bir departman se\u00e7melisiniz."></span>
                    </div>
                    <div class="column-container kisiler-unvan">
                        <label for="kisiler_unvan">\u00dcnvan:</label>
                        <select id="kisiler_unvan" class="form-select" name="unvan_id" required>
                            <option value="" selected>\u00dcnvan se\u00e7iniz</option>
                        </select>
                        <span class="info" data-focus="\u00dcnvan se\u00e7iniz." data-invalid="\u00dcnvan se\u00e7melisiniz."></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="create-dialog-buttons">
            <button type="button" class="create-cancel">\u0130ptal</button>
            <button type="submit" class="create-save">Kaydet</button>
        </div>
    </form>
</dialog>`);
}

export function initKisilerCreateDialog() {
	ensureKisilerCreateDialog();
	const dialog = document.querySelector("#kisilerCreateDialog");
	if (!dialog || didBind) return;
	didBind = true;

	const form = dialog.querySelector("form");
	const tcEl = dialog.querySelector("#kisiler_tc");

	if (tcEl && !tcEl._mask) {
		tcEl._mask = IMask(tcEl, { mask: /^\d{0,11}$/ });

		function syncTcValidity() {
			const len = tcEl.value.length;
			if (len === 0) {
				tcEl.setCustomValidity("");
				return;
			}
			if (len !== 11) tcEl.setCustomValidity("TC kimlik numaras\u0131 11 rakam olmal\u0131d\u0131r.");
			else tcEl.setCustomValidity("");
		}

		tcEl.addEventListener("input", syncTcValidity);
		tcEl.addEventListener("blur", syncTcValidity);
	}

	const trNameRe = /^[a-zA-Z\u011F\u00FC\u015F\u0131\u00F6\u00E7\u011E\u00DC\u015E\u0130\u00D6\u00C7\s'\-]+$/;
	function syncNameValidity(el) {
		const value = el.value.trim();
		if (!value) {
			el.setCustomValidity("");
			return;
		}
		if (!trNameRe.test(value)) el.setCustomValidity("Sadece harf, bo\u015fluk veya tire girebilirsiniz.");
		else el.setCustomValidity("");
	}

	["#kisiler_first_name", "#kisiler_last_name"].forEach((selector) => {
		const el = dialog.querySelector(selector);
		if (!el) return;
		el.addEventListener("input", () => syncNameValidity(el));
		el.addEventListener("blur", () => syncNameValidity(el));
	});

	async function loadDropdowns() {
		const departmanSel = dialog.querySelector("#kisiler_departman");
		const unvanSel = dialog.querySelector("#kisiler_unvan");

		if (departmanSel) {
			departmanSel.innerHTML = '<option value="" selected>Departman se\u00e7iniz</option>';
			try {
				const res = await fetch(`${API}/kisi-departmanlari`);
				const data = await res.json();
				(data.items || []).forEach((item) => {
					const fullLabel = String(item.name ?? "");
					const opt = document.createElement("option");
					opt.value = item.id;
					opt.textContent = truncateLabel(fullLabel, 32);
					opt.title = fullLabel;
					departmanSel.appendChild(opt);
				});
			} catch (err) {
				console.error("Kisi departmanlari yuklenemedi:", err);
			}
		}

		if (unvanSel) {
			unvanSel.innerHTML = '<option value="" selected>\u00dcnvan se\u00e7iniz</option>';
			try {
				const res = await fetch(`${API}/unvanlar`);
				const data = await res.json();
				(data.items || []).forEach((item) => {
					const fullLabel = String(item.name ?? "");
					const opt = document.createElement("option");
					opt.value = item.id;
					opt.textContent = truncateLabel(fullLabel, 32);
					opt.title = fullLabel;
					unvanSel.appendChild(opt);
				});
			} catch (err) {
				console.error("Unvanlar yuklenemedi:", err);
			}
		}
	}

	document.body.addEventListener("click", async (e) => {
		if (e.target.closest(".kisiler-ekle")) {
			dialog.showModal();
			dialog.scrollTop = 0;
			showDialogOverlay(dialog, "Y\u00fckleniyor...");
			await new Promise((r) => setTimeout(r, 350));
			try {
				await loadDropdowns();
			} finally {
				hideDialogOverlay();
			}
		}
		if (e.target.closest(".create-cancel")) {
			dialog.close();
		}
	});

	dialog.addEventListener("close", () => {
		delete dialog.dataset.submitted;
		form?.reset();
		tcEl?.setCustomValidity("");
		dialog.querySelector("#kisiler_first_name")?.setCustomValidity("");
		dialog.querySelector("#kisiler_last_name")?.setCustomValidity("");
	});

	if (form && !form._bound) {
		form._bound = true;
		form.addEventListener("submit", async (e) => {
			e.preventDefault();
			dialog.dataset.submitted = "true";

			if (!form.checkValidity()) {
				showToast("L\u00fctfen t\u00fcm zorunlu alanlar\u0131 doldurunuz.", "error");
				form.querySelector(":invalid")?.scrollIntoView({ behavior: "smooth", block: "center" });
				return;
			}

			const draft = new KisilerDraft(form);
			const payload = draft.toPayload();

			showDialogOverlay(dialog);
			await new Promise((r) => setTimeout(r, 350));
			try {
				const res = await fetch(`${API}/kisiler`, {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(payload),
				});
				const data = await res.json();
				if (!data.ok) {
					showToast(data.error || "Kay\u0131t s\u0131ras\u0131nda hata olu\u015ftu.", "error");
					return;
				}
				showToast("Ki\u015fi ba\u015far\u0131yla eklendi.", "success", false);
				dialog.close();
				const refreshUrl = uiState.kisiler.lastSearchUrl ?? `${API}/kisiler`;
				renderKisilerGrid({ url: refreshUrl, paginationLimit: uiState.kisiler.paginationLimit });
			} catch (err) {
				console.error("POST /kisiler hatasi:", err);
				showToast("Sunucuya ba\u011flan\u0131lamad\u0131.", "error");
			} finally {
				hideDialogOverlay();
			}
		});
	}
}

function showToast(message, type = "success", inDialog = true) {
	Toastify({
		text: message,
		duration: 3000,
		gravity: "top",
		position: "right",
		stopOnFocus: true,
		selector: inDialog ? document.querySelector("#kisilerCreateDialog") : document.body,
		style: {
			background: type === "success" ? "#22c55e" : "#ee4447",
			borderRadius: "8px",
			fontSize: "14px",
			fontWeight: "500",
		},
	}).showToast();
}
